import { SearchEntityType } from '@tribeplatform/gql-client/types';
export const getSearchItemLink = ({ entityType, entityId, in: space, url, }) => {
    var _a, _b;
    switch (entityType) {
        case SearchEntityType.member:
            return `/member/${entityId}`;
        case SearchEntityType.space:
            return `/${((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) || (space === null || space === void 0 ? void 0 : space.slug)}`;
        case SearchEntityType.External:
            return url;
        // Post.
        default:
            return `/${((_b = space === null || space === void 0 ? void 0 : space.address) === null || _b === void 0 ? void 0 : _b.path) || (space === null || space === void 0 ? void 0 : space.slug)}/post/${entityId}`;
    }
};
export const getSearchPageLink = ({ search, type, }) => {
    return `/search?query=${search}${type ? `&type=${type}` : ``}`;
};
// Remove post results with no spaces
export const cleanupSearchResult = data => {
    if (!data)
        return null;
    data.hits = data.hits.map(section => {
        section.hits = section.hits.filter(hit => {
            return !((section === null || section === void 0 ? void 0 : section.entityType) === SearchEntityType.post && !(hit === null || hit === void 0 ? void 0 : hit.in));
        });
        return section;
    });
    data.hits = data.hits.filter(section => section.hits.length);
    return data;
};
//# sourceMappingURL=utils.js.map